import { PixelEventType } from '../fb-pixel/PixelEventNames';

export interface CustomConversion {
  id: number;
  facebookCCIdentifier: string;
  createdTime: number;
  name: string;
  customEventType: PixelEventType;
  rule: string; // string encoded json straight from FB
  businessID?: number;
  facebookPixelIdentifier?: string;
}

export const exampleCustomConversion: CustomConversion = {
  id: 1,
  facebookCCIdentifier: '123',
  createdTime: 1622054656,
  name: 'Make Purchase on Site',
  customEventType: PixelEventType.PURCHASE,
  rule:
    '{"and":[{"event":{"eq":"Purchase"}},{"or":[{"URL":{"i_contains":"order-received"}}]}]}',
};
